import api from './api';

export const listRecordings = async (params = {}) => {
  const { data } = await api.get('/recordings', { params });
  return data;
};

export const updateRecording = async (id, payload) => {
  const { data } = await api.patch(`/recordings/${id}`, payload);
  return data;
};

export default {
  listRecordings,
  updateRecording,
};
